import { createFileRoute } from '@tanstack/react-router'
import { ChequesListPage } from '../../../features/cheques/cheques-list-page'
import { chequeSearchSchema } from '../../../features/cheques/search'

export const Route = createFileRoute('/_app/cheques/')({
  validateSearch: chequeSearchSchema,
  component: ChequesListPage,
})
